import React from "react";
import { observer } from "mobx-react";
import { CreditTierViewStore } from "../../store";
import { CreditTierViewForm } from "./CreditTierViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type CreditTierViewProps = {
  creditTierViewStore: CreditTierViewStore;
};

export const CreditTierView: React.FC<CreditTierViewProps> = observer(
  ({ creditTierViewStore }) => {
    return (
      <div>
        <CreditTierViewForm
          name_es={creditTierViewStore.name_esValue}
          name_en={creditTierViewStore.name_enValue}
          name_pt={creditTierViewStore.name_ptValue}
          monthlyCredits={creditTierViewStore.monthlyCreditsValue}
          pricePerCredit={creditTierViewStore.pricePerCreditValue}
          pricePerExtraCredit={creditTierViewStore.pricePerExtraCreditValue}
          description_es={creditTierViewStore.description_esValue}
          description_en={creditTierViewStore.description_enValue}
          description_pt={creditTierViewStore.description_ptValue}
          onPrint={(handlePrint: () => void) =>
            creditTierViewStore.printCreditTier(handlePrint)
          }
          onCancel={() => creditTierViewStore.cancelCreditTier()}
          onEdit={
            creditTierViewStore.isEditEnabled
              ? () => creditTierViewStore.editCreditTier()
              : undefined
          }
        />
        <ErrorDialog
          open={creditTierViewStore.errorDialogOpened}
          title={creditTierViewStore.errorTitle}
          description={creditTierViewStore.errorDescription}
          onClose={() => creditTierViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
